import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  container: {
    flexShrink: 0,
    marginBottom: "2rem",
    padding: "0",
    width: "270px",

    "& h3": {
      marginTop: "1rem",
      fontFamily: "Inter-Light",
      fontWeight: "normal",
      fontSize: "1.5rem",
      lineHeight: "2rem",
      cursor: "pointer",
    },
  },
  imageContainer: {
    width: "100%",
    paddingBottom: "56.25%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
  },
  "@media screen and (max-width: 1100px)": {
    container: {
      width: "190px",
      marginRight: "5px",
      padding: "0 0 0 0.25rem",

      "& h3": {
        fontSize: "1.25rem",
      },
    },
  },
  "@media screen and (max-width: 400px)": {
    container: {
      width: "160px",
    },
  },
});

function Item({ item, category, index }) {
  const classes = useStyles();

  const handleClick = () => {
    window.FollozeApi.openItemViewer({
      item: item,
      category: category,
      queryString: ``,
    });
  };

  return (
    <div className={classes.container} data-index={index}>
      <div
        onClick={handleClick}
        className={classes.imageContainer}
        style={{
          backgroundImage: `url('${window.FollozeApi.getImageUrl(
            item.image
          )}')`,
        }}
      ></div>
      <h3 onClick={handleClick}>{item.name}</h3>
      {/* <pre>{JSON.stringify(item, null, 2)}</pre> */}
    </div>
  );
}

export default Item;
